import {
  GetComisionMembresiaEmpleadosBaja,
  DeleteComisionMembresiaPagoAnticipado
} from "../../../reducers/comisionMembresia";

export interface PagoAnticipadoStore
  extends GetComisionMembresiaEmpleadosBaja,
    DeleteComisionMembresiaPagoAnticipado {}

export const pagoAnticipadoStore: (state) => PagoAnticipadoStore = state => {
  const comisionMembresia = state.comisionMembresia;

  return {
    empleadosDadosDeBaja: comisionMembresia.empleadosDadosDeBaja,
    gettingEmpleadosDadosDeBaja: comisionMembresia.gettingEmpleadosDadosDeBaja,
    gettingEmpleadosDadosDeBajaError:
      comisionMembresia.gettingEmpleadosDadosDeBajaError,

    pagoAnticipadoRevertido: comisionMembresia.pagoAnticipadoRevertido,
    deletingPagoAnticipado: comisionMembresia.deletingPagoAnticipado,
    deletingPagoAnticipadoError: comisionMembresia.deletingPagoAnticipadoError
  };
};
